<template>
	<div v-if='toolDetail'>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-资源工具池</span>-{{toolDetail.title}}</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			<div class="body-main">
				<div class="main-header">
					<div class="head-left">
						<img :src='getImgSrc(toolDetail.image)' style="width: 238px;height: 238px;" alt="">
					</div>
					<div class="head-right">
						<div class="title">
							{{toolDetail.title}}
						</div>
						<div class="content">
							<div class="content-l">

								<div class="content-item"><span class="biaoti">学科</span>：<span>{{toolDetail.subjectcate_name}}</span></div>
								<div class="content-item"> <span class="biaoti">阶段</span>：<span>{{toolDetail.stage_name}}</span></div>
								<div @click="goto(`/geniusClub/geniusInfo?id=${toolDetail.user_id}`)" class="content-item"> <span class="biaoti">发布人</span>：<span>{{toolDetail.user_nickname}}</span></div>
							</div>
							<div class="content-r">
								<div class="content-item"><span class="biaoti">行业</span>：<span>{{toolDetail.industry_name}}</span></div>
								<div class="content-item"> <span class="biaoti">关 键 词</span>：<span>{{toolDetail.tags}}</span></div>
								<div class="content-item"> <span class="biaoti">创建时间</span>：<span>{{timeConversion(toolDetail.createtime)}}</span><span
										class="biaoti" style="margin-left: 25px;">修改时间</span>：<span>{{timeConversion(toolDetail.createtime)}}</span>
								</div>
							</div>
						</div>
						<div class="bottom">
							<span style="color: #0052D9;"><i class="el-icon-view"
									style="font-size: 20px;"></i>{{toolDetail.hits}}</span>
							<span style="margin-left: 20px;cursor: pointer;" @click="toolDetail.collect = 1"
								:style="toolDetail.collect == 1?'color: #0052D9;':''"><i class="el-icon-star-on"
									style="font-size:20px;"></i>{{toolDetail.collect_num}}</span>
							<span style="margin-left: 20px;cursor: pointer;" v-throttle="[LikeHandler,2000,`click`]" @click="toolDetail.collect = 1"
								:style="toolDetail.praise == 1?'color: #0052D9;':''"><i class="iconfont icon-zan"
									style="font-size:20px;"></i>{{toolDetail.praise_num}}</span>		
							<span style="margin-left: 20px;cursor: pointer;" v-throttle="[ShitHandler,2000,`click`]" @click="toolDetail.collect = 1"
								:style="toolDetail.tread == 1?'color: #0052D9;':''"><i class="iconfont icon-lacai"
									style="font-size:20px;"></i>{{toolDetail.tread_num}}</span>
						</div>
					</div>
				</div>
				<div class="main-body">
					<div class="title">
						<div @click="activeTitel = 1" :class="activeTitel==1?'active':''">资源摘要</div>
						<div @click="payed(2)" :class="activeTitel==2?'active':''" style="margin-left: 20px;">
							资源详情</div>
						<div @click="payed(3)" :class="activeTitel==3?'active':''" style="margin-left: 20px;">
							下载地址</div>
					</div>
					<div class="showItem">
						<div v-if="activeTitel == 1">
							<p v-html="formatRichText(toolDetail.summary_info)">
							</p>  
							<div style='width:700px;height:300px;background:#eee;margin:auto;margin-top:30px;
							padding: 30px 50px;box-sizing: border-box;color: #222;' v-if="toolDetail.is_buy == 0">
								<h3>资源权限详情:</h3>
								<p style="height: auto;width: 100%;margin: 20px;">	您需要支付{{toolDetail.score}}点积分才能查看，连续签到或者发布资源都可以赚取积分哦!</p>
								<p style="height: auto;width: 100%;margin: 20px;">
									实名认证的学生和教学科研人员每日可获得当日积分50点;达到用户级别或成为平台
									管理组成员可以获得更高的积分，详情请查看积分规则。
								</p>
								<div style="margin: auto;background: #0052D9;color: #fff;margin-top: 50px;
										height: 40px;width: 120px;border-radius: 5px;line-height: 40px;text-align: center;cursor: pointer;
								" @click='paySroceTool'>
									支付积分
								</div>
							</div>
							<div class="main-body">
									<h3 style="text-align: center;position: relative;color: #222;">为您推荐相似方案<span style="position: absolute;bottom: -10px;background-color: #0052D9;width:25px;height: 5px;left: 50%;transform: translateX(-50%);"></span></h3>
							
								<div class="showItem">
									<div style="color: black;">
										<div class="body-mid-main" style="display: flex;justify-content: center;">
											<div class="main-item" v-for="(item, index) in alike" :key="index" @click="$router.push(`/solutionDetail?id=${item.id}`)">
												<div class="main-item-pic">
													<img src='../../assets/images/computer.png' alt="">
												</div>
												<div class="main-item-title" style="width: 100px; overflow: hidden;
										                  text-overflow: ellipsis;
										                  max-height: calc(2em + 8px);">
													{{item.title}}
												</div>
											</div>
										</div>
									</div>
							
								</div>
							
							</div>
						</div>
						<div  v-if="activeTitel == 2 ">
						<p v-html="toolDetail.content_info">
						</p>
						</div>
						<el-dialog
						  title="打赏作者"
						  :visible.sync="centerDialogVisible"
						  width="500px"
						  center>
						  <el-input placeholder="请输入支付积分" type="text" v-model.number='payScore'> </el-input>
						  <span slot="footer" class="dialog-footer">
						    <el-button @click="centerDialogVisible = false">取 消</el-button>
						    <el-button type="primary" v-throttle="[giveScore,2000,`click`]">确 定</el-button>
						  </span>
						</el-dialog>
						<div v-if="activeTitel == 3">
							<div class="wangpan"><span>百度网盘：</span><input type="text" disabled :value="toolDetail.down_url"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="body-right">
				<div class="body-right">
					<div style="background: #0052D9;" @click="$router.push('/zyTools/createTools')">
						<img src='../../assets/images/zhifly.png' alt="" style="width: 20px;height: 18px;"><span
							style="width:80px">发布</span>
					</div>
					<div style="background: #3399FF;position: relative;" class="shareBox">
						<img src='../../assets/images/share.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">分享</span>
						<div class="share"
							style="position: absolute;left:0px;background: rgba(255, 255, 255, 0);width: 200px;display: flex;align-items: center;justify-content: center;left: 200px;height: 50px;">
							<goShare @share='reoserceShare' :zytitle="toolDetail.title"></goShare>
						</div>
					</div>
					<div style="background: #FF8F00;"  v-throttle="[collectasd,2000,`click`]">
						<img src='../../assets/images/whiteStar.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:80px">关注</span>
					</div>
					<div style="background: #18BC9C;"  v-throttle="[LikeHandler,2000,`click`]">
						<img src='../../assets/images/dianzan.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:80px">点赞</span>
					</div>
					<div style="background: #182349;" v-throttle="[ShitHandler,2000,`click`]">
						<img src='../../assets/images/diancai.png' alt="" style="width: 20px;height: 19px;"><span
							style="width:80px">点踩</span>
					</div>
					<div style="background:#444C69;" @click="centerDialogVisible = true">
						<img src='../../assets/images/dashang.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">打赏作者</span>
					</div>
					<div style="background:#929292;"  @click="$router.push(`/userCenter/pthd/myMessage?type=3&id=${toolDetail.user_id}`)">
						<img src='../../assets/images/error.png' alt="" style="width: 19px;height:18px;"><span
							style="width:80px">纠错整改</span>
					</div>
					<div style="background:palevioletred;" @click="xiajia()">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">申请下架</span>
					</div>
					<div  style="background:red;" @click="showDialog = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">纠错工单</span>
					</div>
					<div  style="background:brown;" @click="showDialog2 = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">提交问题</span>
					</div>
					<!-- 触发弹出对话框的按钮 -->  
					<!-- 弹出对话框 -->  
					  
				</div>
				<div v-if="showDialog" class="dialog-overlay">
					<div class="dialog-content">  
					<textarea style="height: 300px;" v-model="correctionSuggestions" placeholder="在这里输入您的纠错意见和建议"></textarea>  
					<div class=".dialog-footer">
					  <button  class="submit-btn" @click="submitCorrections">提交</button>  
					  <button  class="cancel-btn" @click="showDialog = false">取消</button>
					</div>
					</div>  
				</div>
				<div v-if="showDialog2" class="dialog-overlay">
					<div class="dialog-content">  
					<textarea style="height: 300px;" v-model="correctionSuggestions2" placeholder="在这里输入您的问题!"></textarea>  
					<div class=".dialog-footer">
					  <button  class="submit-btn" @click="submitCorrections2">提交</button>  
					  <button  class="cancel-btn" @click="showDialog2 = false">取消</button>
					</div>
					</div>  
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import goShare from '../../components/share.vue'
	export default {
		components: {
			goShare
		},
		data() {
			return {
				showDialog: false,  
				correctionSuggestions: '',
				showDialog2: false,
				correctionSuggestions2: '',
				title: '',
				whereForm: "",
				shoucang: false,
				activeTitel: 1,
				toolDetail:{},
				centerDialogVisible:false,
				payScore:'',
				alike:[]
			}
		},
		async created() {
			await this.getToolDetail()
			
		},
		methods:{
			submitCorrections() {  
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo();  
			}, 
			// alikeToolsList
			async alikeList(){
				const alike = await this.$api.alikeToolsList({id:this.toolDetail.id,subjectcate_id:this.toolDetail.subjectcate_id})
				this.alike = alike.data
				console.log(alike);
			},
			//下架
			async xiajia(){
				const alike = await this.$api.add_gongdan({
					user_id:this.toolDetail.user_id,
					pro_id:this.toolDetail.id,
					pro_title:this.toolDetail.title,
					prostatus:0,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
				console.log('下架信息',alike);
			},
			//纠错
			submitCorrections() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo();  
			}, 
			//提交问题
			submitCorrections2() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo2();  
			}, 
			async jiucuo(){
				if(!this.correctionSuggestions){
					this.$message({
						message: "输入您的纠错意见和建议 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_jcgongdan({
					user_id:this.toolDetail.user_id,
					pro_id:this.toolDetail.id,
					pro_title:this.toolDetail.title,
					prostatus:0,
					jccontent:this.correctionSuggestions,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog = false;  
					this.correctionSuggestions = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
				console.log('下架信息',alike);
			},
			async jiucuo2(){
				if(!this.correctionSuggestions2){
					this.$message({
						message: "输入您的问题 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_changjianwenti({
					user_id:this.toolDetail.user_id,
					// pro_id:this.proDetail.id,
					// pro_title:this.proDetail.title,
					cate_list:2,
					question:this.correctionSuggestions2,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog2 = false;  
					this.correctionSuggestions2 = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
			},
			async getDetail(id) {
				const detail = await this.$api.projectneedGetDetail({
					id: id
				})
				this.proDetail = detail.data
				console.log('项目详情',detail.data);
				if (detail.data.project_need_files) {
					this.files = detail.data.project_need_files.split(",")
				}
				this.loding = true
			},
			goto(url) {
				this.$router.push(url)
			},
			getPath(item) {
				this.downLoadPath = item
				this.centerDialogVisible = true
				// if(this.downLoadPWD == this.proDetail.password){
				// 	this.centerDialogVisible = false
				// }
			},
			// payTools
			async paySroceTool(){
				const pay = await this.$api.payTools({id:this.toolDetail.id})
				if(pay.code == 1){
					this.$message({
						message: pay.msg,
						type: 'success',
					})
					this.toolDetail.is_buy = 1
				}else{
					this.$message({
						message: pay.msg,
						type: 'warning',
					})
				}
			},
			payed(page){
				if(this.toolDetail.is_buy == 1){
					this.activeTitel = page
				}else{
					this.$message({
						message: '支付积分查看',
						type: 'warning',
					})
					return
				}
			},
			async giveScore(){
				const score = await this.$api.giveScoreToUserTools({
					user_id:this.toolDetail.user_id,
					score:this.payScore
				})
				if(score.code == 1){
					this.$message({
						message: score.msg,
						type: 'success',
					})
					this.centerDialogVisible = false
					this.payScore = ''
				}else{
					this.$message({
						message: score.msg,
						type: 'warning',
					})
				}
				console.log(score);
			},
			async collectasd() {
				let col
				if (this.toolDetail.collect == 0) {
					 col = await this.$api.collectTools({
						id: this.toolDetail.id
					})
					if (col.code == 1) {
						this.toolDetail.collect = 1
						this.toolDetail.collect_num += 1
					}
				} else {
					 col = await this.$api.cancelCollectTools({
						id: this.toolDetail.id
					})
					if (col.code == 1) {
						this.toolDetail.collect = 0
						this.toolDetail.collect_num -= 1
					}
				}
				this.$message({
					message: col.msg,
					type: 'success',
					center: true
				})
			},	
			// reoserceToolShare
			async reoserceShare(){
				// 1项目需求，2资源工具求助，3资源工具，4解决方案，5解决方案求助，6产品服务求助，7产品服务
				const share = await this.$api.shareHandler({correlation_id:this.toolDetail.id,type:3})
				if (share.code == 1) {
					this.toolDetail.share = 1
				}
			},
			async LikeHandler() {
				let like
				if (this.toolDetail.praise == 0) {
					 like = await this.$api.getLikeTools({
						id: this.toolDetail.id
					})
					if (like.code == 1) {
						this.toolDetail.praise = 1
						this.toolDetail.praise_num += 1
					}
				} else {
					 like = await this.$api.cancelLikeTools({
						id: this.toolDetail.id
					})
					if (like.code == 1) {
						this.toolDetail.praise = 0
						this.toolDetail.praise_num -= 1
					}
				}
				this.$message({
					message: like.msg,
					type: 'success',
					center: true
				})
			},
			// giveShitForTools
			// TakeBackShitFromTools
			async ShitHandler() {
				let shit
				if (this.toolDetail.tread == 0) {
					 shit = await this.$api.giveShitHandler({
						correlation_id: this.toolDetail.id,
						type:3
					})
					if (shit.code == 1) {
						this.toolDetail.tread = 1
						this.toolDetail.tread_num += 1
					}
				} else {
					 shit = await this.$api.cancelGiveShitHandler({
						correlation_id: this.toolDetail.id,
						type:3
					})
					if (shit.code == 1) {
						this.toolDetail.tread = 0
						this.toolDetail.tread_num -= 1
					}
				}
				this.$message({
					message: shit.msg,
					type: 'success',
					center: true
				})
			},
			
			async getToolDetail(){
				const detail =await this.$api.reosureceToolDetail({id:this.$route.query.id})
				if(detail.code !== 1){
					this.$message({
						message:detail.msg,
						type:'error'
					})
				}
				this.toolDetail = detail.data
				 this.alikeList()
			},
			 // openPay() {
			 //        this.$prompt('请输入积分', '打赏作者', {
			 //          confirmButtonText: '确定',
			 //          cancelButtonText: '取消',
			 //        }).then(async({ value }) => {
				// 		const score = await this.$api.giveScoreToUserTools({
				// 			user_id:this.toolsDetail.user_id,
				// 			score:value
				// 		})
				// 		if(score.code == 1){
				// 			this.$message({
				// 				message: score.msg,
				// 				type: 'success',
				// 			})
				// 			// this.centerDialogVisible = false
				// 			// this.payScore = ''
				// 		}else{
				// 			this.$message({
				// 				message: score.msg,
				// 				type: 'warning',
				// 			})
				// 		}
			 //        }).catch(() => {
			              
			 //        });
			 //      }
		},
		
	}
</script>

<style lang="less" scoped>
	.shareBox {
		.share {
			display: none !important;
		}
	
		&:hover {
			.share {
				display: block !important;
			}
		}
	}
	.main-item {
		margin: 13px;
		margin-left: 18px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
	}
	.main-item {
		text-align: center;
		cursor: pointer;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
	}
	
	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;
	
	}
	
	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}
	.body {
		display: flex;
		justify-content: space-between;
	
		.body-main {
			width: 1160px;

			.main-body {
				.showItem {
					padding: 30px 25px;
					color: #888888;
					p{
						width: 1130px;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.wangpan{
						color: black;
						height:200px;
						input{
							border: 1px solid #c6c6c6;
							height: 25px;
							padding-left: 5px;
							width: 200px;
						}
					}
				}

				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						width: 128px;
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						text-align: center;
						color: #888888;
					}

					.active {
						font-weight: bold;
						background: #0052D9;
						color: white;
						border-radius: 20px;
					}
				}

				margin-top: 20px;
				padding: 20px 0;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;
					display: flex;

					.biaoti {
						width: 70px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 20px 5px;
					}

					.content-l {
						width: 300px;

					}
				}

				.bottom {
					display: flex;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 15px;
				}


				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
	/* 弹出对话框的覆盖层 */  
	.dialog-overlay {  
		
	}  
	  
	/* 对话框内容 */  
	.dialog-content {  
	  background: white;  
	  padding: 20px;  
	  border-radius: 8px;  
	  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);  
	  width: 400px; /* 稍微增加宽度以适应更大的文本域 */  
	  text-align: center;  
	}  
	  
	/* 文本域美化并放大 */  
	.text-area {  
	  width: 350px; /* 减去更大的左右padding */  
	  height: 500px; /* 增加高度 */  
	  padding: 20px; /* 增加内边距 */  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 16px; /* 增加字体大小 */  
	  line-height: 1.6; /* 稍微增加行高以保持可读性 */  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}
	  
	/* 文本域美化 */  
	.text-area {  
	  width: calc(100% - 40px); /* 减去左右padding */  
	  padding: 10px;  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 14px;  
	  line-height: 1.5;  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}  
	  
	/* 对话框底部按钮样式 */  
	.dialog-footer {  
	  display: flex;  
	  justify-content: center;  
	  gap: 10px; /* 按钮间的间距 */  
	}  
	  
	.submit-btn, .cancel-btn {  
	  padding: 10px 20px;  
	  font-size: 16px;  
	  border: none;  
	  border-radius: 4px;  
	  cursor: pointer;  
	  transition: background-color 0.3s; /* 添加过渡效果 */  
	}  
	  
	.submit-btn {  
	  background-color: #4CAF50; /* 绿色 */  
	  color: white;  
	}  
	  
	.submit-btn:hover {  
	  background-color: #45a049; /* 悬停时颜色变深 */  
	}  
	  
	.cancel-btn {  
	  background-color: #f44336; /* 红色 */  
	  color: white;  
	}  
	  
	.cancel-btn:hover {  
	  background-color: #da190b; /* 悬停时颜色变深 */  
	}  
</style>